import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/** Whether the browser's Back would land on an FTL page. React Router keeps `idx` in
 *  `window.history.state`: 0 on the first entry of a tab's in-app history, +1 per push
 *  (react-router lib/router/history.ts, getUrlBasedHistory). */
export function hasAppPageBehind(): boolean {
  const idx = (window.history.state as { idx?: unknown } | null)?.idx;
  return typeof idx === "number" && idx > 0;
}

/**
 * A Back that never leaves the app (row e7a3f5f3, Claire's link check 1 Nov): `navigate(-1)` on
 * a page opened from a shared link, a bookmark or a new tab stepped out of FTL to a blank page.
 * With no FTL page behind, Back opens `fallback`, the page above this one, in its place.
 * Otherwise it is the browser's Back, as before.
 */
export function useGoBack(fallback: string): () => void {
  const navigate = useNavigate();
  return useCallback(() => {
    if (hasAppPageBehind()) navigate(-1);
    else navigate(fallback, { replace: true });
  }, [navigate, fallback]);
}
